import { createAppRequest } from '@/services/request';
import type { ApiRequestOptions } from './types/common';
import type {
  DictionaryItem,
  DictionaryPageResult,
  DictionaryPayload,
  DictionaryQueryParams,
} from './types/dictionary';

const request = createAppRequest();
const BASE_PATH = '/bff/zy-crm/industries';

export async function queryIndustries(
  params: DictionaryQueryParams,
  options?: ApiRequestOptions,
) {
  return request<DictionaryPageResult>(BASE_PATH, {
    method: 'GET',
    params,
    ...(options || {}),
  });
}

export async function createIndustry(payload: DictionaryPayload, options?: ApiRequestOptions) {
  return request<DictionaryItem>(BASE_PATH, {
    method: 'POST',
    data: payload,
    ...(options || {}),
  });
}

export async function updateIndustry(
  uuid: string,
  payload: DictionaryPayload,
  options?: ApiRequestOptions,
) {
  return request<DictionaryItem>(`${BASE_PATH}/${uuid}`, {
    method: 'PATCH',
    data: payload,
    ...(options || {}),
  });
}

export async function deleteIndustry(uuid: string, options?: ApiRequestOptions) {
  return request<void>(`${BASE_PATH}/${uuid}`, {
    method: 'DELETE',
    ...(options || {}),
  });
}
